import { FC } from 'react'
import shallow from 'zustand/shallow'

import { useAuth } from '../../../context/auth-context'
import { ReviewerTable } from './ReviewerTable'
import { ReviewerInfoBox } from './ReviewerInfoBox'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useCompanySettingsStore } from '../CompanySettingsStore'
import { useCompanySettingsReviewer } from '../../../graphql/companySettings/useCompanySettingsReviewer'

export const CompanySettingsReviewerTab: FC = () => {
  const { user } = useAuth()
  const [selected] = useCompanySettingsStore((state) => [state.selected], shallow)

  const isHrAdmin = !!user.roles && user.roles.filter((role) => role.toString() === `HR_ADMIN_${selected.country}`).length > 0

  const { loading, data, error } = useCompanySettingsReviewer(selected.companyId)

  const hasNoData =
    !data ||
    !data.checkCompanyManagerOfCompany ||
    !data.reviewersByCompanyId ||
    !data.activeEmployeesOfCompany ||
    !data.activeEmployeesOfCompanyWithoutPartners

  const isLoadingOrError = loading || error || hasNoData

  if (isLoadingOrError) {
    return <LoadingAndErrors isLoading={loading} hasNoData={hasNoData} error={error} showSpinner />
  } else {
    const canEdit = isHrAdmin || data!.checkCompanyManagerOfCompany.permit
    return (
      <>
        <ReviewerInfoBox
          activeEmployeesOfCompany={data!.activeEmployeesOfCompany || []}
          activeEmployeesOfCompanyWithoutPartners={data!.activeEmployeesOfCompanyWithoutPartners || []}
          existingRelations={data!.reviewersByCompanyId}
          canEdit={canEdit}
        />
        <ReviewerTable tableData={data!.reviewersByCompanyId} canEdit={canEdit} isHrAdmin={isHrAdmin} />
      </>
    )
  }
}
